import { render, staticRenderFns } from "./Buttons.vue?vue&type=template&id=ae7be9dc&"
import script from "./Buttons.vue?vue&type=script&lang=js&"
export * from "./Buttons.vue?vue&type=script&lang=js&"
import style0 from "./Buttons.vue?vue&type=style&index=0&id=ae7be9dc&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nicholashaskell/Local/kicknic/app/public/wp-content/themes/kicknic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae7be9dc')) {
      api.createRecord('ae7be9dc', component.options)
    } else {
      api.reload('ae7be9dc', component.options)
    }
    module.hot.accept("./Buttons.vue?vue&type=template&id=ae7be9dc&", function () {
      api.rerender('ae7be9dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/scripts/components/panels/form/Buttons.vue"
export default component.exports